
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function AITutoringPreview() {
  const benefits = [
    "24/7 access to AI tutors specialized in your exam subjects",
    "Get instant explanations to complex concepts",
    "Personalized learning assistance based on your needs",
    "Multi-format learning with text, voice, and visuals",
    "Doubt solving with step-by-step explanations",
    "Exam-specific guidance from expert AI systems"
  ];
  
  const screenshots = [
    {
      url: "/lovable-uploads/fe1e2f12-51ca-4277-84b1-340333d19e1a.png",
      caption: "AI Learning Studio - Get personalized assistance 24/7"
    },
    {
      url: "/lovable-uploads/40370903-845a-4564-b160-2a0f15129e32.png",
      caption: "Adaptive Learning - Personalized content based on your needs"
    }
  ];

  return (
    <FeatureShowcase
      title="AI Tutoring Studio"
      description="Get personalized learning assistance with our advanced AI tutoring systems."
      featureName="AI Tutoring"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
